import { http, HttpResponse, passthrough } from "msw";
import { handleMockRequest } from "@/mocks/router";

const useRealSession = String(import.meta.env.VITE_SESSION_USE_REAL ?? "false") === "true";

/** Only login create goes to real backend when enabled; everything else stays on MSW. */
function isRealSessionRoute(method: string, pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return method === "POST" && p === "/api/session/create";
}

async function fromRequest(request: Request) {
  const url = new URL(request.url);
  if (useRealSession && isRealSessionRoute(request.method.toUpperCase(), url.pathname)) {
    return passthrough();
  }
  let body: unknown;
  if (request.method !== "GET" && request.method !== "HEAD") {
    const text = await request.text();
    body = text ? JSON.parse(text) : undefined;
  }
  const result = handleMockRequest({
    method: request.method,
    path: url.pathname,
    query: url.searchParams,
    body,
    headers: {
      cookie: request.headers.get("cookie") || "",
    },
  });
  return HttpResponse.json(result.body as never, { status: result.status });
}

/** MSW handlers — match any origin so Node/browser tests both work. */
export const handlers = [
  http.get("*/api/*", ({ request }) => fromRequest(request)),
  http.post("*/api/*", ({ request }) => fromRequest(request)),
  http.put("*/api/*", ({ request }) => fromRequest(request)),
  http.patch("*/api/*", ({ request }) => fromRequest(request)),
  http.delete("*/api/*", ({ request }) => fromRequest(request)),
];
